import * as Yup from "yup";

export const ValidationSchema = (t?: any) =>
    Yup.object().shape({
        title: Yup.string().required("Title is required!").min(1).max(128),
        description: Yup.string().required("Description is required!").min(1),
        timeToRead: Yup.number().required("Time To Read is required!").min(1),
    });
